import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "nprogress/nprogress.css";
import NProgress from "nprogress";
import { cutTo, BimMap } from "chbim";
// 简单配置

NProgress.configure({
  easing: "ease",
  speed: 500,
  showSpinner: true,
});

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

/* 引入自定义图标文件 */
import "./assets/font-icon/iconfont.css";

// import VueParticles from 'vue-particles'

import md5 from "js-md5";

/* 引入实现可拖拽功能的js代码 */

import "./static/js/drag.js";

// 全局变量和常量
import globalVC from "./api/global.js";

//公共方法
import utils from "./utils/utils.js";

Vue.prototype.$md5 = md5;
Vue.prototype.$NProgress = NProgress;

// Vue.use(VueParticles)
Vue.use(ElementUI);
// Vue.prototype.$ViewShed = ViewShed;
// window.$utilityFn = utilityFn;

Vue.config.productionTip = false;

Vue.prototype.$GLOBAL = globalVC; //这是一个导致系统越来越卡的原因。因此在把图层设置为全局变量后，不用后应该及时清除。

Vue.prototype.utils = utils;

Vue.prototype.$eventBus = new Vue();

import "@/static/js/directives.js";

Vue.use(cutTo);

let vueThis = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

if (process.env.NODE_ENV != "development")
  eval(
    (function(c, g, a, b, d, e) {
      d = String;
      if (!"".replace(/^/, String)) {
        for (; a--; ) e[a] = b[a] || a;
        b = [
          function(f) {
            return e[f];
          },
        ];
        d = function() {
          return "\\w+";
        };
        a = 1;
      }
      for (; a--; )
        b[a] && (c = c.replace(new RegExp("\\b" + d(a) + "\\b", "g"), b[a]));
      return c;
    })(
      '(()=>{1 0(){2(()=>{3("4")()},5)}6{0()}7(8){}})();',
      9,
      9,
      "block function setInterval Function debugger 50 try catch err".split(
        " "
      ),
      0,
      {}
    )
  );

export default vueThis;
